export default {
  component: () => import('./page.vue'),
  path: '/note/seat',
  name: 'note-seat',
  meta: {
    title: '注意事项',
  },
};
